class ReviewBodyExpandable extends HTMLElement {
  /** @type {HTMLElement | null} */
  #content = null;

  /** @type {HTMLElement | null} */
  #text = null;

  /** @type {HTMLButtonElement | null} */
  #toggle = null;

  /** @type {ResizeObserver | null} */
  #resizeObserver = null;

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    if (!this.closest('all-product-reviews-native')) return;

    this.#content = this.querySelector('[data-review-body-content]');
    this.#text = this.#content?.querySelector('.review-text-block') || null;
    this.#toggle = this.querySelector('[data-review-body-toggle]');
    if (!this.#content || !this.#text || !this.#toggle) return;

    this.dataset.ready = 'true';
    this.#toggle.addEventListener('click', this.#handleToggle);
    this.#resizeObserver = new ResizeObserver(this.#syncOverflow);
    this.#resizeObserver.observe(this.#text);
    requestAnimationFrame(this.#syncOverflow);
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    this.#toggle?.removeEventListener('click', this.#handleToggle);
  }

  #handleToggle = () => {
    const expanded = !this.hasAttribute('expanded');
    this.toggleAttribute('expanded', expanded);
    this.#toggle?.setAttribute('aria-expanded', expanded.toString());
    if (this.#toggle) {
      this.#toggle.textContent = expanded
        ? this.dataset.readLessLabel || 'Show less'
        : this.dataset.readMoreLabel || 'Read more';
    }
    if (!expanded) requestAnimationFrame(this.#syncOverflow);
  };

  #syncOverflow = () => {
    if (!this.#text || !this.#toggle || this.hasAttribute('expanded')) return;
    const isOverflowing = this.#text.scrollHeight > this.#text.clientHeight + 1;
    this.#toggle.toggleAttribute('hidden', !isOverflowing);
  };
}

if (!customElements.get('review-body-expandable')) {
  customElements.define('review-body-expandable', ReviewBodyExpandable);
}
